import { CompositeDecorator } from "draft-js";
import React, { useState } from 'react'

const Highlight = (props) => <span style={{ display: 'inline' }} className="suggested-word"
    onClick={(e) => {
        props.setActiveWord(e.currentTarget.innerText)
        const popupref = document.querySelector(".spell-suggestions")
        const src_pos = e.target.getBoundingClientRect()
        //Parent advanced-text-area
        const advancedTextArea = document.querySelector(".advanced-text-area");
        if (!advancedTextArea) return;
        const targ_pos = advancedTextArea.getBoundingClientRect()
        //Shift popup
        popupref.style.left = (src_pos.x - targ_pos.x + 10) + 'px'
        popupref.style.top = (src_pos.y - targ_pos.y + 30) + 'px'
        popupref.style.display = 'block'
    }}>
    <span style={{ borderBottom: "1px solid #fe0000" }} >{props.children}</span>
</span>

const FillerBracket = (props) => {
    const [showHover, setShowHover] = useState('');
    const [word, setWord] = useState('')
    return <span style={{ color: '#FE4959' }}>{props.children}</span>
}

export default class DraftEditorDecorator {

    constructor(review_params) {
        if (review_params) {
            const { words, spell_list } = review_params;
            this.words = words;
            // this.bwords = words;
            this.spell_list = spell_list;
            this.setActiveWord = review_params.setActiveWord
        }
        
        // Safe matchAll polyfill for older browsers
        this.safeMatchAll = (text, regex) => {
            if (typeof text.matchAll === 'function') {
                return [...text.matchAll(regex)];
            } else {
                // Fallback for older browsers
                const matches = [];
                let match;
                while ((match = regex.exec(text)) !== null) {
                    matches.push(match);
                    // Prevent infinite loop on global regex
                    if (!regex.global) break;
                }
                return matches;
            }
        }
        
        this.Decorated = ({ children }) => <Highlight spell_list={this.spell_list} setActiveWord={this.setActiveWord}>{children}</Highlight>;
        this.findWithRegex = (words, contentBlock, callback) => {
            //Space will take care of start and last word
            const text = ' ' + contentBlock.getText() + ' ';
            words.forEach(word => {
                const regexp = new RegExp(`\[\\s\.\,\-](${word.trim()})[\\s\.\,\-]`, 'g');
                const matches = this.safeMatchAll(text, regexp);
                matches.forEach(match =>
                    callback(match.index , match.index + match[1].length )
                );
            });
        }
        this.handleStrategy = (contentBlock, callback) => {
            this.findWithRegex(this.words, contentBlock, callback);
        }
        this.handleFillerWordsStrategy = (contentBlock, callback) => {
            const text = contentBlock.getText();
            const matches = this.safeMatchAll(text, /\[([^\]]{1,50})\]/g);
            matches.forEach(match => //Exclude brackets [ ] +1 -1
                callback(match.index + 1, match.index + match[0].length - 1)
            );
        }
        this.FillerDecorated = ({ children }) => <FillerBracket>{children}</FillerBracket>
        this.createBasicDecorator = () =>
            new CompositeDecorator([
                {
                    strategy: this.handleFillerWordsStrategy,
                    component: this.FillerDecorated
                }
            ]);
        this.createWithSpellCheckDecorator = () =>
            new CompositeDecorator([
                {
                    strategy: this.handleStrategy,
                    component: this.Decorated
                },
                {
                    strategy: this.handleFillerWordsStrategy,
                    component: this.FillerDecorated
                }
            ]);
    }
}